import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Type from 'prop-types';
import { userStore } from 'stores';

const renderComponent = (children, render, props) => {
  return render ? render(props) : children;
};

const PrivateRoute = ({ children = null, render = null, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      return userStore.isLoggedIn ? (
        renderComponent(children, render, props)
      ) : (
        <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

PrivateRoute.propTypes = {
  children: Type.node,
  render: Type.func,
  location: Type.shape({
    hash: Type.string,
    pathname: Type.string,
    search: Type.string,
    key: Type.string,
  }),
};

PrivateRoute.defaultProps = {
  children: null,
  render: null,
  location: {},
};

export default PrivateRoute;
